import React, { Component } from 'react';
import styles from './ImageGrid.module.css';
import BgImage from './BgImage';
import * as Constants from '../Constants';
import { Col, Row } from 'reactstrap';
import { Gallery, Item } from 'react-photoswipe-gallery';
import { hasWebpSupport } from './SupportDetection';

export default class ImageGrid extends Component {

    height = 230;
    width = 350;

    constructor(props) {
        super(props);
        this.state = {
            isPsOpen: false,
            psOptions: {
                history: false,
                loop: false,
                bgClickAction: 'close',
                tapAction: function(point, event) {
                    const target = event && event.target;
                    if (target && target.classList && (
                        target.classList.contains('pswp__item') ||
                        target.classList.contains('pswp__zoom-wrap') ||
                        target.classList.contains('pswp__bg')
                    )) {
                        this.close();
                    }
                },
            }
        };
    }

    hasCount() {
        return this.props.images != null && this.props.images.length > 3;
    }

    getWidth() {
        return this.width;
    }

    getHeight() {
        return this.props.hasOwnProperty('height') ? this.props.height : this.height;
    }

    getHalfHeight() {
        return this.getHeight() / 2;
    }

    handlePsOpen(open, event) {
        if (open) {
            open(event);
        }
        this.setState({ ...this.state, isPsOpen: true, psOptions: { ...this.state.psOptions } });
    }

    handlePsClose() {
        this.setState({ ...this.state, isPsOpen: false });
    }

    toGalleryItem(image) {
        // the 1000/1000 is the width/height limit
        return { original: this.getUrl(image.url + '1000/1000'), width: image.width, height: image.height, title: image.description }
    }

    getUrl(url) {
        return Constants.TOBOGAURL + url.replace('/jpg', (hasWebpSupport() ? '/webp' : '/jpg'));
    }

    handleClick(open, event) {
        this.handlePsOpen(open, event);
    }

    renderGalleryLink(index, children) {
        const item = this.toGalleryItem(this.props.images[index]);

        return (
            <Item
                original={item.original}
                width={item.width}
                height={item.height}
                title={item.title}
            >
                {({ open, ref }) => (
                    <div
                        ref={ref}
                        className={styles.link}
                        onClick={event => this.handleClick(open, event)}
                    >
                        {children}
                    </div>
                )}
            </Item>
        );
    }

    render() {
        var images = this.props.images;
        if (!images || images.length === 0) {
            return ("");
        }
        return (
            <Gallery
                options={this.state.psOptions}
                onClose={() => this.handlePsClose()}
            >
                <Row className={styles.imageGrid}>

                    {images.length > 0 &&
                        <Col xs={images.length === 1 ? 12 : 8}>
                            {this.renderGalleryLink(0,
                                <BgImage url={this.getUrl(images[0].url) + this.getWidth() + '/'} height={this.getHeight()}
                                    className={styles.img1} type={BgImage.types.cover} />
                            )}
                        </Col>
                    }

                    {images.length > 1 &&
                        <Col xs={4}>
                            {this.renderGalleryLink(1,
                                <BgImage url={this.getUrl(images[1].url) + 'null/' + (images.length === 2 ? this.getHeight() : this.getHalfHeight())}
                                    height={images.length === 2 ? this.getHeight() : this.getHalfHeight()}
                                    className={styles.img2} type={BgImage.types.cover} />
                            )}

                            {images.length > 2 &&
                                <div className={styles.countContainer}>
                                    {this.renderGalleryLink(2,
                                        <>
                                            {images.length > 3 &&
                                                <div className={styles.countValue}>+{images.length - 3}</div>
                                            }
                                            <BgImage url={this.getUrl(images[2].url) + 'null/' + this.getHalfHeight()} height={this.getHalfHeight()}
                                                className={styles.img3} type={BgImage.types.cover} />
                                        </>
                                    )}
                                </div>
                            }
                        </Col>
                    }
                </Row>
            </Gallery>
        );
    }
}
